import { RequestHelper } from "@/helper/requestHelper";
import Recommend from '../models/recommend';
import RecommendId from '../models/recommend-id';
import RecommendGateway from '../models/recommend-gateway';

/**
 * 広告を扱うAPI
 */
export default class RecommendApi implements RecommendGateway {
    /**
     * 広告を取得する
     */
    public top(uuid: string, platform: string): Promise<Recommend[]> {
        const params = {
            uuid,
            platform
        };
        return new Promise((resolve, reject) => {
            RequestHelper.post(
                "get_recommend_v2",
                params,
                res => {
                    const recommends: any[] = JSON.parse(res).data;
                    resolve(recommends.map(toRecommend));
                },
                reject
            );
        });
    }

    /**
     * 閲覧された広告を記録する
     */
    public log(id: RecommendId, uuid: string, platform: string): Promise<void> {
        const params = {
            uuid,
            platform,
            recommendId: String(id)
        };
        return new Promise((resolve, reject) => {
            RequestHelper.post(
                "click_recommend",
                params,
                () => {
                    resolve();
                },
                reject
            );
        });
    }
}

function toRecommend(data: any): Recommend {
    return {
        id: data.id,
        url: data.url,
        image: data.image
    };
}
